module.exports = __webpack_public_path__ + "Admin_Dashboard_Mockup-ea72bf0bb6ad9e55cd6929aae7b8e0d1.png";